/**
 * InquiryList component - displays list of inquiries with filtering
 */

import { InquiryCard } from './InquiryCard';
import { EmptyState } from '../ui/empty-state';
import { Skeleton } from '../ui/skeleton';
import { MessageSquare } from 'lucide-react';
import type { InquiryWithAssignment, LeadInquiryStatus } from '../../services/inquiriesApi';

interface InquiryListProps {
  inquiries: InquiryWithAssignment[];
  isLoading: boolean;
  onStatusChange: (id: string, status: LeadInquiryStatus) => void;
  onConvert: (inquiry: InquiryWithAssignment) => void;
  onDelete: (id: string) => void;
}

function InquiryCardSkeleton() {
  return (
    <div className="border rounded-lg p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 space-y-3">
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-32" />
            <Skeleton className="h-5 w-16 rounded-full" />
          </div>
          <div className="flex gap-4">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-4 w-24" />
          </div>
          <Skeleton className="h-4 w-full" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-8 w-24" />
          <Skeleton className="h-8 w-8" />
        </div>
      </div>
    </div>
  );
}

export function InquiryList({
  inquiries,
  isLoading,
  onStatusChange,
  onConvert,
  onDelete,
}: InquiryListProps) {
  if (isLoading) {
    return (
      <div className="space-y-4">
        {[1, 2, 3].map((i) => (
          <InquiryCardSkeleton key={i} />
        ))}
      </div>
    );
  }

  if (inquiries.length === 0) {
    return (
      <EmptyState
        icon={MessageSquare}
        title="No hay consultas"
        description="Las nuevas consultas del formulario de contacto aparecerán aqui"
      />
    );
  }

  return (
    <div className="space-y-4">
      {inquiries.map((inquiry) => (
        <InquiryCard
          key={inquiry.id}
          inquiry={inquiry}
          onStatusChange={onStatusChange}
          onConvert={onConvert}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
